import { Outlet } from "react-router-dom";

const WhatsGoingOnPage = Outlet

export default WhatsGoingOnPage